// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the fee configuration form */
.fee-config-container {
  margin: 20px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  background-color: #ffe6e6;
  text-align: center;
}
.form-flex-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two equal columns */
  gap: 10px; /* Space between fields */
  align-items: center;
  margin-bottom: 20px;
}

/* Heading styles */
.fee-config-heading {
  font-size: 32px; 
  font-weight: bold; 
  text-align: center;
  color: #007bff;
  margin-bottom: 20px;
}

/* Style for the input groups */
.fee-input-group label {
  text-align: left; /* Left-align label */
  font-size: 18px; /* Increased font size */
  margin-bottom: 2px;
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
}



/* Input field styles */
.fee-input {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}
.fee-select {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
}

/* Button styles */
.submit-button {
  grid-column: span 2; /* Span both columns */
  padding: 8px 16px; /* Adjusted size */
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  cursor: pointer;
  margin-top: 1px;
  align-self: center;
  justify-self: center;
}

.submit-button:hover {
  background-color: #0056b3;
}

/* Table container */
.fee-table-container {
  margin: 30px auto;
  max-width: 800px;
  text-align: center;
}

/* Table styles */
.fee-table {
  width: 100%;
  border-collapse: collapse;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.fee-table th,
.fee-table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
  font-size: 14px;
}

.fee-table th {
  background-color: #007bff;
  color: #fff;
  font-weight: bold;
}

.fee-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.fee-table tbody tr:hover {
  background-color: #e9e9e9;
}

/* Icon button styles */
.icon-button {
  border: none;
  background: none;
  cursor: pointer;
  padding: 5px;
}

.icon-button:hover {
  color: #0056b3;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .fee-config-container {
    padding: 15px;
    grid-template-columns: 1fr; /* Single column for small screens */
  }

  .fee-input-group {
    width: 100%;
  }

  .fee-input,
  .fee-select {
    font-size: 12px;
  }

  .submit-button {
    font-size: 14px;
    grid-column: span 1; /* Reset button width on smaller screens */
  }

  .fee-table-container {
    width: 100%;
    overflow-x: auto;
  }

  .fee-table th,
  .fee-table td {
    padding: 10px 12px;
    font-size: 12px;
  }
}

.delete-btn {
  color: #f54f4f;
  cursor: pointer;
}

.delete-btn:hover {
  color: red;
}

.edit-button {
  color: #007bff;
  border: none;
  background: none;
  cursor: pointer;
}

.edit-button:hover {
  color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/MyFees/FeeConfig.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC,EAAE,sBAAsB;EAC7D,SAAS,EAAE,yBAAyB;EACpC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB,EAAE,qBAAqB;EACvC,eAAe,EAAE,wBAAwB;EACzC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;;;AAIA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB,EAAE,sBAAsB;EAC3C,iBAAiB,EAAE,kBAAkB;EACrC,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,0BAA0B,EAAE,oCAAoC;EAClE;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB,EAAE,0CAA0C;EACjE;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Container for the fee configuration form */\n.fee-config-container {\n  margin: 20px auto;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  background-color: #ffe6e6;\n  text-align: center;\n}\n.form-flex-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* Two equal columns */\n  gap: 10px; /* Space between fields */\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n/* Heading styles */\n.fee-config-heading {\n  font-size: 32px; \n  font-weight: bold; \n  text-align: center;\n  color: #007bff;\n  margin-bottom: 20px;\n}\n\n/* Style for the input groups */\n.fee-input-group label {\n  text-align: left; /* Left-align label */\n  font-size: 18px; /* Increased font size */\n  margin-bottom: 2px;\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #333;\n}\n\n\n\n/* Input field styles */\n.fee-input {\n  padding: 4px 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #fff;\n}\n.fee-select {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 16px;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #fff;\n}\n\n/* Button styles */\n.submit-button {\n  grid-column: span 2; /* Span both columns */\n  padding: 8px 16px; /* Adjusted size */\n  border: none;\n  border-radius: 4px;\n  background-color: #007bff;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 1px;\n  align-self: center;\n  justify-self: center;\n}\n\n.submit-button:hover {\n  background-color: #0056b3;\n}\n\n/* Table container */\n.fee-table-container {\n  margin: 30px auto;\n  max-width: 800px;\n  text-align: center;\n}\n\n/* Table styles */\n.fee-table {\n  width: 100%;\n  border-collapse: collapse;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.fee-table th,\n.fee-table td {\n  padding: 12px 15px;\n  border: 1px solid #ddd;\n  text-align: left;\n  font-size: 14px;\n}\n\n.fee-table th {\n  background-color: #007bff;\n  color: #fff;\n  font-weight: bold;\n}\n\n.fee-table tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\n.fee-table tbody tr:hover {\n  background-color: #e9e9e9;\n}\n\n/* Icon button styles */\n.icon-button {\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.icon-button:hover {\n  color: #0056b3;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .fee-config-container {\n    padding: 15px;\n    grid-template-columns: 1fr; /* Single column for small screens */\n  }\n\n  .fee-input-group {\n    width: 100%;\n  }\n\n  .fee-input,\n  .fee-select {\n    font-size: 12px;\n  }\n\n  .submit-button {\n    font-size: 14px;\n    grid-column: span 1; /* Reset button width on smaller screens */\n  }\n\n  .fee-table-container {\n    width: 100%;\n    overflow-x: auto;\n  }\n\n  .fee-table th,\n  .fee-table td {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n}\n\n.delete-btn {\n  color: #f54f4f;\n  cursor: pointer;\n}\n\n.delete-btn:hover {\n  color: red;\n}\n\n.edit-button {\n  color: #007bff;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n.edit-button:hover {\n  color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
